export default __webpack_public_path__ + "static/media/ukrainegot-screenshot-01.b087d410.png";